import {defineStore} from 'pinia';
import {ModuleInventoryCategory} from '../../moduleConst';
import ColumnCommon from '@/commons/wildcards/constants/ColumnCommon';
import inventoryCategoryAPI from '@/apis/di/inventoryCategoryAPI';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore.js';
import {useStockStore} from '@/stores/dictionary/stock/stockStore';

const inventoryCategoryStore = new BaseDictionaryStore(inventoryCategoryAPI);

export const useInventoryCategoryStore = defineStore(ModuleInventoryCategory, {
  state: () => ({
    ...inventoryCategoryStore.state,
    _config: {
      key: 'inventory_category_id',
      code: 'inventory_category_code',
      table: 'di_inventory_category',
      posted: ColumnCommon.isPosted,
      moduleName: 'Loại vật tư/CCDC',
      quickFollow: 'active',
      isTree: true,
      defaultSort: 'inventory_category_code',
    },
    moduleName: 'inventory_category',
  }),
  actions: {
    ...inventoryCategoryStore.action,

    /**
     * Lấy dữ liệu inventory_category thông qua một api mới viết trên server
     */
    getDataForCombobox(param) {
      return inventoryCategoryAPI.getInventoryCategoryForCombobox(param);
    },

    /**
     * Xào nấu lại dữ liệu để binding lên combobox
     * Loại bỏ trường parent_id
     */
    filterDataForCombobox() {
      return this.$state.items;
    },

    /**
     *
     * @returns
     */
    getDataStockFromStockStore() {
      const storeStock = useStockStore();
      const dataStock = storeStock.provideDataStock();
      return dataStock;
    },
  },

  getters: {
    ...inventoryCategoryStore.getters,
  },
});
